import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterLink } from "@angular/router";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { SimplebarAngularModule } from 'simplebar-angular';
import {
EventTypesSelectorCardComponent
} from '../components/templates/event-types-selector-card/event-types-selector-card.component';
import {
EventCategoriesInputComponent
} from '../custom-forms-module/components/event-categories-input/event-categories-input.component';
import { CustomFormsModule } from '../custom-forms-module/custom-forms.module';
import { DaveCommentsModule } from '../dave-comments/dave-comments.module';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveFileExplorerModule } from '../dave-file-explorer/dave-file-explorer.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import {
DropzoneComponent
} from "../dave-utils-module/dave-shared-components-module/components/dropzone/dropzone.component";
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { IconPipeModule } from '../dave-utils-module/icon-pipe/icon-pipe.module';
import { SelectEventTypeComponent } from "../select-event-type/select-event-type.component";
import { SelectEventTypeDirective } from "../select-event-type/select-event-type.directive";
import { SmallFileCardModule } from '../small-file-card/small-file-card.module';
import { DetailTasksComponent } from './components/detail-tasks/detail-tasks.component';
import { EventCardComponent } from './components/event-card/event-card.component';


@NgModule({
    declarations: [EventCardComponent, DetailTasksComponent],
    imports: [
        CommonModule,
        MatExpansionModule,
        AppButtonModule,
        MatTooltipModule,
        MatListModule,
        FontAwesomeModule,
        MatChipsModule,
        IconPipeModule,
        DaveSharedComponentsModule,
        DropzoneModule,
        MatDialogModule,
        ReactiveFormsModule,
        SimplebarAngularModule,
        MatCardModule,
        DaveDoubleIconModule,
        MatFormFieldModule,
        DaveLoadingModule,
        SmallFileCardModule,
        DaveFileExplorerModule,
        MatTabsModule,
        DaveCommentsModule,
        CustomFormsModule,
        MatCheckboxModule,
        FormsModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        EventTypesSelectorCardComponent,
        SelectEventTypeComponent,
        SelectEventTypeDirective,
        DropzoneComponent,
        RouterLink,
        RouterLink,
        DragDropModule,
        MatIconModule,
        EventCategoriesInputComponent,
    ],
    exports: [EventCardComponent, DetailTasksComponent],
})
export class DaveEventCardModule {}
